var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99935 9.02733C6.72331 9.02733 6.49927 8.80333 6.49927 8.52733V0.5C6.49927 0.224 6.72331 0 6.99935 0C7.2754 0 7.49944 0.224 7.49944 0.5V8.52733C7.49944 8.80333 7.2754 9.02733 6.99935 9.02733",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99931 9.02752C6.86662 9.02752 6.7386 8.97485 6.64525 8.88019L4.70091 6.92885C4.50621 6.73285 4.50687 6.41618 4.70224 6.22152C4.89828 6.02685 5.21433 6.02685 5.40903 6.22285L6.99931 7.81952L8.58959 6.22285C8.78429 6.02685 9.10034 6.02685 9.29638 6.22152C9.49174 6.41618 9.49241 6.73285 9.29771 6.92885L7.35337 8.88019C7.26002 8.97485 7.132 9.02752 6.99931 9.02752",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15219_1120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 14,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.330933 3.15479H13.6665V12.3175H0.330933V3.15479Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15219_1120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7161 12.3175H3.28812C1.65783 12.3175 0.330933 10.9915 0.330933 9.36079V6.10412C0.330933 4.47745 1.6545 3.15479 3.28211 3.15479H3.90956C4.18561 3.15479 4.40964 3.37879 4.40964 3.65479C4.40964 3.93079 4.18561 4.15479 3.90956 4.15479H3.28211C2.20593 4.15479 1.33111 5.02879 1.33111 6.10412V9.36079C1.33111 10.4401 2.20859 11.3175 3.28812 11.3175H10.7161C11.7909 11.3175 12.6664 10.4421 12.6664 9.36745V6.11145C12.6664 5.03212 11.7883 4.15479 10.7101 4.15479H10.0886C9.81259 4.15479 9.58855 3.93079 9.58855 3.65479C9.58855 3.37879 9.81259 3.15479 10.0886 3.15479H10.7101C12.3404 3.15479 13.6666 4.48145 13.6666 6.11145V9.36745C13.6666 10.9941 12.3424 12.3175 10.7161 12.3175",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7dbe12f0bf6112034b7f111b8213a8d0.svg";
export { ForwardRef as ReactComponent };